<template>
  <div class="leftTreeBody">
    <div id="leftTreeSelect">
      <a-row style="margin-bottom: 8px; align-items:center;" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_time_analysis_range')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-range-picker
            :allowClear="false"
            :value="[moment(filter.startTime), moment(filter.endTime)]"
            :format="'YYYY-MM-DD'"
            @change="rangeChange"
          />
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items:center;" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_business_equipment_type')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-select
            style="width:100%"
            mode="multiple"
            :maxTagCount="1"
            :value="filter.deviceTypeId"
            :placeholder="$t('page_device_edit_please_enter_the_device_type')"
            @change="selectType"
          >
            <a-select-option v-for="(item, index) in deviceTypes" :key="index" :value="item.key">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items:center;" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_ops_alarm_type')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-select
            style="width:100%"
            show-search
            optionFilterProp="children"
            :value="filter.issueType"
            :placeholder="$t('page_ops_alarm_type_select')"
            @change="selectIssueType"
          >
            <template v-for="(item, index) in issueTypes">
              <a-select-option :value="item.dictKey" :key="index">
                {{ item.dictValue }}
              </a-select-option>
            </template>
          </a-select>
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items:center;" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_ops_alarm_code')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-input
            style="width:100%"
            :value="filter.alarmCode"
            :placeholder="$t('page_ops_alarm_code_input')"
            @change="changeAlarmCode"
          />
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items:center" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_ops_machine_info')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-input
            style="width:100%"
            :value="filter.workStationInfo"
            :placeholder="$t('page_ops_name_or_no_input')"
            @change="changeWorkStationName"
          />
        </a-col>
      </a-row>
      <a-row style="margin-bottom: 8px; align-items:center" type="flex">
        <a-col style="text-align: right; font-size: 15px;" :span="7">
          <ellipsis :length="10" tooltip>{{$t('page_ops_customer_customer_name')}}</ellipsis>：
        </a-col>
        <a-col :span="17">
          <a-input
              style="width:100%"
              v-model="filter.customerName"
              :placeholder="$t('page_ops_customer_enter_customer_name')"
          />
        </a-col>
      </a-row>
    </div>
    <div class="mdc-left-tree" style="height: calc(100% - 277px)">
      <a-tree
        v-if="treeData.length>0"
        :tree-data="treeData"
        :defaultExpandedKeys="expandedKeys"
        :defaultCheckedKeys="expandedKeys"
        checkable
        :replaceFields="{children:'children', title: 'name', key: 'code'}"
        @check="checkTree"
      />
    </div>
    <div class="button-save">
      <!-- <a-button type="default" @click="hanldeOutPut()">{{ $t('page_time_analysis_output') }}</a-button> -->
      <a-button style="margin-left: 8px;" type="primary" @click="handelSearch()">{{
        $t('page_time_analysis_search')
      }}</a-button>
    </div>
  </div>
</template>

<script>
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import {
  DictServiceProxy,
  RegionServiceProxy
} from '@/service-proxies/app-v2/system.service-proxies'
import { CustomerServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import {CustomerServiceProxy as mccsp } from "@/service-proxies/app-v2/masterlink-cps-client.service-proxies"

const rsp = new RegionServiceProxy()
const csp = new CustomerServiceProxy()
const dbsp = new DictServiceProxy()
const dtsp = new DeviceTypeServiceProxy()
const api = new mccsp();

import { getTenantInfo } from '@/utils/auth'

import moment from 'moment'
import dayjs from 'dayjs'

export default {
  name: 'left-tree',
  data() {
    return {
      filter: {
        deviceTypeId: [],
        issueType: '0',
        startTime: dayjs()
          .subtract(7, 'day')
          .format('YYYY-MM-DD'),
        endTime: dayjs().format('YYYY-MM-DD'),
        alarmCode: '',
        workStationInfo: '',
        customerName: '',
        customerIdList: [],
      },
      deviceTypes: [],
      issueTypes: [],
      clientHeight: 0,
      treeData: [],
      expandedKeys: ['00-00'],
    }
  },
  created() {
    this.issueTypes = []
    this.deviceTypes = []
    this.getTypeList()
    this.getDictionary()
    this.getTreeList()
  },
  methods: {
    moment,
    selectType(value) {
      this.filter.deviceTypeId = value
    },
    selectIssueType(value) {
      this.filter.issueType = value
    },
    changeAlarmCode(value) {
      this.filter.alarmCode = value.target.value
    },
    changeWorkStationName(value) {
      this.filter.workStationInfo = value.target.value
    },
    handelSearch() {
      if(!this.filter.customerIdList.length) {
         return this.$message.warning(this.$t('page_ops_work_record_customer_required'))
      }
      const value = {
        customerName: this.filter.customerName,
        deviceTypeIdList: this.filter.deviceTypeId,
        startTime: this.filter.startTime,
        endTime: this.filter.endTime,
        alarmCode: this.filter.alarmCode,
        issueType: this.filter.issueType == 0 ? '' : this.filter.issueType,
        workStationInfo: this.filter.workStationInfo,
        customerIdList: this.filter.customerIdList,
      }
      this.$emit('search', value)
    },
    async getDictionary() {
      const aa = {
        code: 'issue-type',
        dictKey: '0',
        dictValue: this.$t('page_device_all_type'),
        id: null,
        isDeleted: null,
        isSealed: null,
        parentId: null,
        remark: null,
        sort: 0
      }
      this.issueTypes = [aa]
      const issueTypes = await dbsp.dictionary('issue-type')
      this.issueTypes = this.issueTypes.concat(issueTypes.data)
    },
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      const list = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
      this.filter.deviceTypeId = list.map((res) => res.key)
      this.deviceTypes = this.deviceTypes.concat(list)
    },
    rangeChange(value) {
      if (value && value.length) {
        this.filter.startTime = dayjs(value[0]).format('YYYY-MM-DD')
        this.filter.endTime = dayjs(value[1]).format('YYYY-MM-DD')
      }
    },
    // 树选择空间处理方法
    async getTreeList() {
      const tenant = getTenantInfo()
      const tenantCode = tenant ? tenant : '根节点'
      const treeData = [
        {
          code: '00-00',
          id: undefined,
          name: tenantCode,
          isLeaf: false,
          isProv: false
        }
      ]
      const { data } = await api.getRegionCustomerDetail();
      treeData[0].children = data;
      const arr = this.getIds(data);
      this.filter.customerIdList = arr;
      this.treeData = treeData;
      this.handelSearch();
    },
    getIds(data) {
      let tmp = [];
      var fun = function (arr) {
        if(arr && arr.length>0) {
          for(let i = 0;i<arr.length; i++) {
            const item = arr[i];
            if(item.flag!==null && item.flag) {
              tmp.push(item.code);
            }
            if(item.children && item.children.length>0) {
              fun(item.children);
            }
          }
        }
      }
      fun(data);
      return tmp;
    },
    checkTree(checkedKeys, {checkedNodes}) {
      const ids = this.filterNode(checkedNodes);
      this.filter.customerIdList = ids;
    },
    filterNode(arr) {
      if(arr.length>0) {
        return arr.flatMap(v=>{
          const item = v.data.props;
          if(item.flag) {
            return [item.code]
          }else{
            return []
          }
        });
      } else{
        return  [];
      }
    }
  }
}
</script>

<style lang="less" scoped>
.leftTreeBody {
  height: 100%;
  padding: 8px;
  min-width: 320px;
  overflow: hidden;
}
.mdc-left-tree {
  border: 1px solid #e9e9e9;
  margin-bottom: 8px;
  overflow: auto;
}
.button-save {
  position: absolute;
  width: 100%;
  text-align: right;
  left: 0;
  padding: 0 8px;
  bottom: 8px;
}
/deep/ .ant-tree li .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper {
  width: 100%;
  background-color: #fff1b8;
}
/deep/ .ant-tree li .ant-tree-node-content-wrapper {
  width: 100%;
}
</style>
